import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 0,
  },
  reportTitle: {
    color: '#000000',
    fontSize: 12,
  },
});

const Michelle = () => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>Michelle Strong Group</Text>
  </View>
);

export default Michelle;
